import { render } from "./custom-number.vue?vue&type=template&id=3bc328f9"
import script from "./custom-number.vue?vue&type=script&lang=js"
export * from "./custom-number.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Cater-Frontend\\cater\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__